import React from 'react';
import { Link } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { IndexedRow, Store } from '@uderly/react-uderly-ui/models';
import Settings from '../../settings';

export interface StoreBreadcrumbsProps {
  store: Store;
  item: IndexedRow;
  path: string;
  onClick: () => void;
  friendlyPath?: string;
}

export function StoreBreadcrumbs(props) {
  const { store, item, path, onClick, friendlyPath } = props;

  return <div className="breadcrumbs">
    <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
      <Link to={"/" + store.subdomain}>
        <Avatar className="avatar"
          src={Settings.apiUrl + "/stores/" + store.id + "/image/thumb?t=" + Date.now()}>{store.name && store.name.substr(0, 1)}</Avatar>
        {store.subdomain}
      </Link>

      <Link to={"/" + store.subdomain + path} onClick={onClick}>
        {friendlyPath ?? path.replace("/", "")}
      </Link>

      {item && item.id && <span>{item.id}</span>}
    </Breadcrumbs>
  </div>;
}
